/* nc-buy — PDP buy box controller. Ported from the source DCLogic (React → vanilla).
   Tier/mode selection + price sync across every surface, gallery (desktop thumbs / mobile carousel),
   sticky bars + sheet, accordions (one-at-a-time), and the dispatch state machine (real clock in
   production). Cart wiring is a real /cart/add.js POST when variant ids are bound, else preview flash.
   Self-contained, per-instance, no globals. Timers torn down on shopify:section:unload. */
(function () {
  'use strict';

  var DW = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var DS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function init(root) {
    if (root.__ncBuyReady) return;
    root.__ncBuyReady = true;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var d = root.dataset;

    var cfg = {
      barBehavior: d.barBehavior || 'kith',
      cutoffHour: parseInt(d.cutoffHour, 10) || 20,
      dispatchDays: (d.dispatchDays || '0123456').split('').map(Number),
      liveWithin: 8,
      bottledDate: d.bottledDate || '',
      nextBatchEta: d.nextBatchEta || '',
      lowStock: parseInt(d.lowStock, 10) || 25,
      inventory: d.inventory === '' || d.inventory == null ? null : parseInt(d.inventory, 10),
      panelState: d.panelState || 'auto',
      timeScenario: d.timeScenario || 'auto'
    };

    var st = {
      tier: parseInt(d.defaultTier, 10) || 2,
      mode: 'one',
      img: 0,
      sheet: false,
      picked: false,
      accOpen: -1,
      dpPhase: reduce ? 2 : 0,
      nowTick: Date.now(),
      email: '',
      emailDone: false,
      emailErr: false
    };
    var timers = {};
    var soldOut = false;

    var $ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var one = function (sel) { return root.querySelector(sel); };

    // Price typography (source moneyEl): Advercase 400, pence at .58em raised .45em.
    // Merchant text is written as safe DOM nodes (never innerHTML). Parse defensively.
    var PRICE_RE = /^£(\d+)\.(\d{2})$/;
    function renderPrice(el, str) {
      if (!el) return;
      el.textContent = '';
      var m = PRICE_RE.exec((str || '').trim());
      if (m) {
        el.appendChild(document.createTextNode('£' + m[1] + '.'));
        var sup = document.createElement('span');
        sup.className = 'buy-pence';
        sup.textContent = m[2];
        el.appendChild(sup);
      } else {
        el.textContent = str || '';
      }
    }
    function priceEl(str, fs) {
      var sp = document.createElement('span');
      sp.className = 'buy-price';
      if (fs) sp.style.fontSize = fs;
      renderPrice(sp, str);
      return sp;
    }
    function setMixed(el, nodes) {
      if (!el) return;
      el.textContent = '';
      for (var i = 0; i < nodes.length; i++) {
        el.appendChild(typeof nodes[i] === 'string' ? document.createTextNode(nodes[i]) : nodes[i]);
      }
    }

    /* ---------------- price + tier + mode ---------------- */
    var tierEls = $('.buy-tier');
    // clamp default tier to a rendered tier (schema max can exceed the block count)
    if (!root.querySelector('.buy-tier[data-tier="' + st.tier + '"]')) {
      var tFirst = one('.buy-tier');
      st.tier = tFirst ? (parseInt(tFirst.getAttribute('data-tier'), 10) || 1) : 1;
    }

    function tierData(n, key) {
      var el = root.querySelector('.buy-tier[data-tier="' + n + '"]');
      return el ? el.getAttribute('data-' + key) || '' : '';
    }
    function activePrice(n) { return st.mode === 'sub' ? tierData(n, 'price-sub') : tierData(n, 'price-one'); }
    function activeSave(n) { return st.mode === 'sub' ? tierData(n, 'save-sub') : tierData(n, 'save-one'); }

    function applyTierAndMode() {
      tierEls.forEach(function (el) {
        var n = el.getAttribute('data-tier');
        el.classList.toggle('is-sel', n === String(st.tier));
        el.setAttribute('aria-checked', n === String(st.tier) ? 'true' : 'false');
        var p = el.querySelector('.buy-tier-price');
        var s = el.querySelector('.buy-tier-save');
        if (p) renderPrice(p, (st.mode === 'sub' ? el.getAttribute('data-price-sub') : el.getAttribute('data-price-one')) || '');
        if (s) s.textContent = (st.mode === 'sub' ? el.getAttribute('data-save-sub') : el.getAttribute('data-save-one')) || '';
      });

      var price = activePrice(st.tier);
      var name = tierData(st.tier, 'name');
      var days = parseInt(tierData(st.tier, 'days'), 10) || 30;
      var firstPrice = tierData(1, 'price-one') || price;

      // main + sheet CTA price spans (Advercase + superscript pence)
      $('.buy-cta-price').forEach(function (e) { renderPrice(e, price); });
      // top bar (desktop): name · price @13px
      var topMeta = one('.buy-topbar-meta');
      if (topMeta) setMixed(topMeta, [name + ' · ', priceEl(price, '13px')]);
      // bottom bar (mobile): FROM £x OR £x · ONE-TIME/SUBSCRIPTION @12.5px
      var barPrice = one('.buy-botbar-price');
      if (barPrice) {
        if (st.picked) setMixed(barPrice, [priceEl(price, '12.5px'), (st.mode === 'sub' ? ' · SUBSCRIPTION' : ' · ONE-TIME')]);
        else setMixed(barPrice, ['FROM ', priceEl(firstPrice, '12.5px')]);
      }
      var barCta = one('.buy-botbar-cta');
      if (barCta && !soldOut) barCta.textContent = st.picked ? 'Add to basket' : 'Select plan';

      // mode link + sub terms (main + sheet copies)
      var linkText = st.mode === 'one'
        ? (root.getAttribute('data-mode-one') || 'Prefer your next course to arrive before this one runs out?')
        : ('It will \u2014 ' + name + ' arrives every ' + days + ' days.');
      $('.buy-mode-link').forEach(function (l) { l.textContent = linkText; });
      root.classList.toggle('is-sub', st.mode === 'sub');
      $('.buy-mode-toggle').forEach(function (t) { t.setAttribute('aria-pressed', st.mode === 'sub' ? 'true' : 'false'); });
    }

    // tier click (main + sheet)
    function pickTierEl(el) {
      st.tier = parseInt(el.getAttribute('data-tier'), 10);
      applyTierAndMode(); // picked flips only on an add action (source semantics)
    }
    $('.buy-tier').forEach(function (el) {
      el.addEventListener('click', function () { pickTierEl(el); });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); pickTierEl(el); }
      });
    });
    // mode toggle (main + sheet)
    $('.buy-mode-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () { st.mode = st.mode === 'one' ? 'sub' : 'one'; applyTierAndMode(); });
    });

    /* ---------------- gallery ---------------- */
    // desktop thumbs
    $('.buy-thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        st.img = parseInt(btn.getAttribute('data-img'), 10) || 0;
        $('.buy-thumb').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        var main = one('.buy-main-img');
        if (main) main.style.backgroundImage = 'url("' + btn.getAttribute('data-src') + '")';
      });
    });
    // mobile carousel progress
    var car = one('.buy-carousel');
    var prog = one('.buy-carousel-prog');
    if (car && prog) {
      car.addEventListener('scroll', function () {
        var max = car.scrollWidth - car.clientWidth;
        var p = max > 0 ? car.scrollLeft / max : 0;
        prog.style.width = (8 + p * 92) + '%';
      }, { passive: true });
    }

    /* ---------------- accordions (one at a time) ---------------- */
    $('.buy-acc').forEach(function (acc, i) {
      var head = acc.querySelector('.buy-acc-head');
      if (!head) return;
      head.addEventListener('click', function () {
        var willOpen = st.accOpen !== i;
        $('.buy-acc').forEach(function (a, j) {
          var openNow = j === i && willOpen;
          a.classList.toggle('is-open', openNow);
          var h = a.querySelector('.buy-acc-head');
          if (h) h.setAttribute('aria-expanded', openNow ? 'true' : 'false');
        });
        st.accOpen = willOpen ? i : -1;
      });
    });

    /* ---------------- add to cart (real POST or preview) ---------------- */
    var adding = false;
    function addToCart(srcBtn) {
      if (soldOut || adding) return;
      // stock not yet confirmed (auto checking phase) — don't take the order blind
      if (cfg.panelState === 'auto' && st.dpPhase < 2) return;
      var variant = st.mode === 'sub' ? tierData(st.tier, 'variant-sub') : tierData(st.tier, 'variant-one');
      var plan = st.mode === 'sub' ? tierData(st.tier, 'selling-plan') : '';
      st.picked = true;

      if (!variant) { // preview mode — flash only
        flashCtas(); flashBarBtn(srcBtn);
        return;
      }
      var body = { items: [{ id: Number(variant), quantity: 1 }] };
      if (plan) body.items[0].selling_plan = Number(plan);
      adding = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      }).then(function () {
        adding = false;
        flashCtas(); flashBarBtn(srcBtn);
        document.dispatchEvent(new CustomEvent('nc:cart:added', { bubbles: true }));
      }).catch(function () {
        adding = false;
        flashError(); // honest failure — never claim "Added" when the cart is empty
      });
    }

    function flashBarBtn(btn) {
      if (!btn || !btn.classList) return;
      btn.classList.add('is-added');
      var prev = btn.textContent;
      btn.textContent = 'Added';
      clearTimeout(timers.barReset);
      timers.barReset = setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = prev; }, 1500);
    }

    function flashError() {
      $('.buy-cta').forEach(function (b) {
        b.classList.add('is-error');
        var lbl = b.querySelector('.buy-cta-inner');
        if (lbl) { b.setAttribute('data-prev', lbl.innerHTML); lbl.textContent = 'Couldn\u2019t add \u2014 try again'; }
      });
      clearTimeout(timers.ctaReset);
      timers.ctaReset = setTimeout(function () {
        $('.buy-cta').forEach(function (b) {
          b.classList.remove('is-error');
          var lbl = b.querySelector('.buy-cta-inner');
          if (lbl && b.getAttribute('data-prev')) lbl.innerHTML = b.getAttribute('data-prev');
        });
      }, 2200);
    }

    function flashCtas() {
      $('.buy-cta').forEach(function (b) {
        b.classList.add('is-added');
        var lbl = b.querySelector('.buy-cta-inner');
        if (lbl) { b.setAttribute('data-prev', lbl.innerHTML); lbl.textContent = 'Added to basket'; }
      });
      clearTimeout(timers.ctaReset);
      timers.ctaReset = setTimeout(function () {
        $('.buy-cta').forEach(function (b) {
          b.classList.remove('is-added');
          var lbl = b.querySelector('.buy-cta-inner');
          if (lbl && b.getAttribute('data-prev')) lbl.innerHTML = b.getAttribute('data-prev');
        });
      }, 1500);
    }

    $('.buy-cta').forEach(function (b) { if (b.classList.contains('buy-sheet-add')) return; b.addEventListener('click', function () { addToCart(); }); });

    /* ---------------- sticky bars + sheet ---------------- */
    var botbar = one('.buy-botbar');
    var topbar = one('.buy-topbar');
    var mainCta = one('.buy-cta-main');
    var scrollHost = window; // section lives in normal page flow (merged from the artboard scroller)

    function updateBars() {
      if (topbar && mainCta) {
        var cr = mainCta.getBoundingClientRect();
        var past = cr.bottom < window.innerHeight * 0.4;
        topbar.classList.toggle('is-shown', past);
      }
      if (botbar && mainCta) {
        if (cfg.barBehavior === 'always') { botbar.classList.add('is-shown'); }
        else {
          var r = mainCta.getBoundingClientRect();
          var pastCta = r.bottom < 0;
          var nearTop = window.scrollY < 40;
          botbar.classList.toggle('is-shown', nearTop || pastCta); // kith: visible at top + after passing the CTA, hidden mid-scroll (source semantics)
        }
      }
    }
    var barRaf = 0;
    var onScroll = function () { if (barRaf) return; barRaf = requestAnimationFrame(function () { barRaf = 0; updateBars(); }); };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateBars(); // paint the initial bar state — fresh load fires no scroll event

    // bottom bar button: open sheet if nothing picked, else add
    var botCta = one('.buy-botbar-cta');
    if (botCta) botCta.addEventListener('click', function () {
      if (soldOut) return;
      if (!st.picked) openSheet(true); else addToCart(botCta);
    });
    // top bar button
    var topCta = one('.buy-topbar-cta');
    if (topCta) topCta.addEventListener('click', function () { if (!soldOut) addToCart(topCta); });

    var sheetLastFocus = null;
    function openSheet(open) {
      st.sheet = open;
      var sheet = one('.buy-sheet');
      var back = one('.buy-sheet-backdrop');
      if (sheet) sheet.hidden = !open;
      if (back) back.hidden = !open;
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) {
        sheetLastFocus = document.activeElement;
        var f = sheet && sheet.querySelector('[role="radio"], button, [href], input');
        if (f && f.focus) f.focus();
      } else if (sheetLastFocus && sheetLastFocus.focus) {
        sheetLastFocus.focus(); sheetLastFocus = null;
      }
    }
    var onSheetKey = function (e) {
      if (!st.sheet) return;
      if (e.key === 'Escape') { openSheet(false); return; }
      if (e.key === 'Tab') {
        var sheet = one('.buy-sheet'); if (!sheet) return;
        var f = sheet.querySelectorAll('[role="radio"], button, [href], input, [tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    };
    document.addEventListener('keydown', onSheetKey);
    $('[data-buy-sheet-close]').forEach(function (b) { b.addEventListener('click', function () { openSheet(false); }); });
    var sheetAdd = one('.buy-sheet-add');
    if (sheetAdd) sheetAdd.addEventListener('click', function () { st.picked = true; openSheet(false); applyTierAndMode(); addToCart(); });

    /* ---------------- dispatch state machine ---------------- */
    function iso(dt) { return dt.getFullYear() + '-' + String(dt.getMonth() + 1).padStart(2, '0') + '-' + String(dt.getDate()).padStart(2, '0'); }
    function isDispatch(dt) { return cfg.dispatchDays.indexOf(dt.getDay()) !== -1; }
    function fmtDate(dt) { return DS[dt.getDay()] + ' ' + dt.getDate() + ' ' + MS[dt.getMonth()]; }
    function fmtHour(h) { return (h % 12 === 0 ? 12 : h % 12) + (h >= 12 ? 'pm' : 'am'); }
    function nextDispatchFrom(dt, inclToday) {
      var x = new Date(dt); if (!inclToday) x.setDate(x.getDate() + 1);
      for (var i = 0; i < 21; i++) { if (isDispatch(x)) return x; x.setDate(x.getDate() + 1); }
      return x;
    }

    // "ships today" must be honest in the WAREHOUSE's timezone, not the visitor's device clock
    function londonNow(ms) {
      try {
        var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false }).formatToParts(new Date(ms));
        var o = {}; parts.forEach(function (x) { o[x.type] = x.value; });
        return new Date(+o.year, +o.month - 1, +o.day, +o.hour % 24, +o.minute, +o.second);
      } catch (e) { return new Date(ms); }
    }

    function computeDispatch() {
      var scen = cfg.timeScenario;
      var now = londonNow(st.nowTick);
      if (scen === 'morning-static') { now = nextDispatchFrom(now, true); now.setHours(7, 0, 0, 0); }
      else if (scen === 'live-countdown') { now = nextDispatchFrom(now, true); now.setHours(13, 19, 0, 0); }
      else if (scen === 'post-cutoff') { now = nextDispatchFrom(now, true); now.setHours(21, 30, 0, 0); }
      else if (scen === 'weekend') { var w = new Date(now); while (w.getDay() !== 6) w.setDate(w.getDate() + 1); w.setHours(11, 0, 0, 0); now = w; }
      // scen 'auto' → real clock (st.nowTick)

      var stock = 'in-stock';
      if (cfg.inventory != null) stock = cfg.inventory <= 0 ? 'sold-out' : (cfg.inventory <= cfg.lowStock ? 'low-stock' : 'in-stock');
      var ps = cfg.panelState;
      if (ps === 'in-stock' || ps === 'low-stock' || ps === 'sold-out') stock = ps;
      var checking = ps === 'checking' || (ps === 'auto' && st.dpPhase < 2);
      soldOut = stock === 'sold-out' && !checking;

      var cut = new Date(now); cut.setHours(cfg.cutoffHour, 0, 0, 0);
      var shipsToday = isDispatch(now) && now < cut;
      var dispatchDate, pre = '', em = '', post = '';
      if (shipsToday) {
        dispatchDate = new Date(now);
        var msLeft = cut - now;
        if (msLeft / 3600000 > cfg.liveWithin) { pre = 'Order by '; em = fmtHour(cfg.cutoffHour); post = ' today for same-day dispatch.'; }
        else { var h = Math.floor(msLeft / 3600000); var m = Math.floor((msLeft % 3600000) / 60000); pre = 'Order in the next '; em = h + 'h ' + m + 'm'; post = ' — ships today.'; }
      } else {
        dispatchDate = nextDispatchFrom(now, false);
        var tom = new Date(now); tom.setDate(tom.getDate() + 1);
        var isTom = iso(dispatchDate) === iso(tom);
        pre = 'Order now — ships '; em = isTom ? 'first thing tomorrow' : DW[dispatchDate.getDay()] + ' morning'; post = '.';
      }
      var sub1 = shipsToday ? 'today, before ' + fmtHour(cfg.cutoffHour) : 'now';
      var sub2 = shipsToday ? 'today' : (em === 'first thing tomorrow' ? 'tomorrow' : DW[dispatchDate.getDay()]);
      var sub3 = 'est. ' + fmtDate(new Date(now.getTime() + 172800000));
      var batch = stock === 'in-stock'
        ? 'Ships from the current run — bottled ' + cfg.bottledDate + '. Small batches sell through in 2 to 3 weeks.'
        : stock === 'low-stock'
          ? 'This batch is nearly gone. The next lands ' + cfg.nextBatchEta + ' — order today and yours ships from the current run.'
          : 'This batch sold out. The next lands ' + cfg.nextBatchEta + '.';
      return { checking: checking, stock: stock, soldOut: soldOut, pre: pre, em: em, post: post, sub1: sub1, sub2: sub2, sub3: sub3, batch: batch, batchShow: stock !== 'in-stock' };
    }

    function paintDispatch() {
      var dp = computeDispatch();
      root.classList.toggle('dp-checking', dp.checking);
      root.classList.toggle('dp-resolved', !dp.checking);
      root.classList.toggle('dp-soldout', dp.soldOut);
      // checking choreography (source :725-726): p0 = line1 pulse + line2 dim; p1 = line1 done + line2 pulse
      var pcls = cfg.panelState === 'checking' ? 'p1' : (st.dpPhase === 0 ? 'p0' : 'p1');
      root.classList.toggle('dp-p0', dp.checking && pcls === 'p0');
      root.classList.toggle('dp-p1', dp.checking && pcls === 'p1');
      root.setAttribute('data-stock', dp.stock);

      $('.buy-dp-headline').forEach(function (e) {
        e.hidden = dp.soldOut;
        var pre = e.querySelector('.buy-dp-pre'); if (pre) pre.textContent = dp.pre;
        var em = e.querySelector('.buy-dp-em'); if (em) em.textContent = dp.em;
        var po = e.querySelector('.buy-dp-post'); if (po) po.textContent = dp.post;
      });
      $('.buy-dp-sub1').forEach(function (e) { e.textContent = dp.sub1; });
      $('.buy-dp-sub2').forEach(function (e) { e.textContent = dp.sub2; });
      $('.buy-dp-sub3').forEach(function (e) { e.textContent = dp.sub3; });
      $('.buy-dp-batch').forEach(function (e) { e.textContent = dp.batch; e.hidden = !dp.batchShow; });

      // sold-out → dead CTAs + reveal email capture
      $('.buy-cta, .buy-botbar-cta, .buy-topbar-cta').forEach(function (b) { b.classList.toggle('is-dead', dp.soldOut); });
      $('.buy-dp-soldout').forEach(function (e) { e.hidden = !dp.soldOut; });
      if (dp.soldOut) {
        $('.buy-cta-inner').forEach(function (e) { e.textContent = 'Sold out'; });
        if (botCta) botCta.textContent = 'Sold out';
        if (topCta) topCta.textContent = 'Sold out';
      }
    }

    // sold-out email capture (design UI + optional Klaviyo action)
    var emailInput = one('.buy-dp-email-input');
    var emailSubmit = one('.buy-dp-email-submit');
    var action = root.getAttribute('data-email-action') || '';
    if (emailInput) emailInput.addEventListener('input', function () { st.email = emailInput.value; root.classList.remove('dp-email-err'); });
    if (emailSubmit) emailSubmit.addEventListener('click', function () {
      var ok = /.+@.+\..+/.test((st.email || '').trim());
      if (!ok) { root.classList.add('dp-email-err'); return; }
      root.classList.remove('dp-email-err');
      if (action) {
        var fd = new FormData(); fd.append('email', st.email.trim());
        fetch(action, { method: 'POST', body: fd, mode: 'no-cors' }).catch(function () {});
      }
      root.classList.add('dp-email-done');
    });

    /* ---------------- dispatch resolve timeline + tick ---------------- */
    if (!reduce && cfg.panelState === 'auto') {
      timers.dp1 = setTimeout(function () { st.dpPhase = 1; paintDispatch(); }, 600);
      timers.dp2 = setTimeout(function () { st.dpPhase = 2; paintDispatch(); }, 1200);
    } else {
      st.dpPhase = 2;
    }
    timers.tick = setInterval(function () { st.nowTick = Date.now(); paintDispatch(); }, 30000);

    /* ---------------- init paint ---------------- */
    applyTierAndMode();
    paintDispatch();

    /* ---------------- teardown ---------------- */
    root.__ncBuyTeardown = function () {
      Object.keys(timers).forEach(function (k) { clearTimeout(timers[k]); clearInterval(timers[k]); });
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      document.removeEventListener('keydown', onSheetKey);
      if (barRaf) cancelAnimationFrame(barRaf);
      document.body.style.overflow = '';
    };
  }

  function boot() { document.querySelectorAll('[data-nc-buy]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-nc-buy]') : null;
    if (el) init(el);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-nc-buy]') : null;
    if (el && typeof el.__ncBuyTeardown === 'function') el.__ncBuyTeardown();
  });
})();
